import { makeStyles } from 'tss-react/mui'
import { primary, red } from '../../assets/colors'

export const useStyles = makeStyles()((theme) => {
    const numFeatures = "'tnum' on, 'lnum' on"

    return {
        table: {
            tableLayout: 'fixed',
            border: 0,
        },
        tableRow: {
            border: 'none',
        },
        headerCell: {
            padding: '2px',
            color: theme.palette.text.disabled,
            textAlign: 'right',
            border: 0,
            '&:first-of-type': {
                textAlign: 'left',
            },
        },
        rowCell: {
            padding: '2px',
            textAlign: 'right',
            fontSize: '13px',
            lineHeight: 1.2,
            border: 0,
            fontFeatureSettings: numFeatures,
            '&:first-of-type': {
                textAlign: 'left',
            },
        },
        bidCell: {
            color: primary,
        },
        askCell: {
            color: red,
        },
        totalLabelCell: {
            color: theme.palette.text.secondary,
            textAlign: 'left',
        },
        totalPct: {
            color: theme.palette.text.secondary,
            fontSize: '11px',
            lineHeight: 1.2,
            marginRight: theme.spacing(0.75),
        },
        tradeable: {
            cursor: 'pointer',
            '&: hover td': {
                color: 'unset',
            },
        },
    }
})
